import React from 'react';
import { MessageCircle, Mail, Phone, Video, Inbox } from 'lucide-react';

const iconMap = {
  messages: MessageCircle,
  email: Mail,
  calls: Phone,
  meeting: Video,
  default: Inbox
};

/**
 * EmptyState - Displays a centered empty state message with optional icon
 */
const EmptyState = ({
  icon = 'default',
  title = 'No items found',
  description,
  action,
  actionLabel,
  className = ''
}) => {
  const Icon = typeof icon === 'string' ? (iconMap[icon] || iconMap.default) : icon;

  return (
    <div className={`flex flex-col items-center justify-center h-full text-gray-500 p-8 ${className}`}>
      {Icon && (
        <Icon size={48} className="mb-4 text-gray-600" />
      )}
      <p className="text-sm font-medium text-gray-400">{title}</p>
      {description && (
        <p className="text-xs text-gray-500 mt-1 text-center max-w-xs">{description}</p>
      )}
      {action && actionLabel && (
        <button
          onClick={action}
          className="mt-4 px-4 py-2 bg-purple-600 hover:bg-purple-500 text-white text-sm font-medium rounded-lg transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
